<template>
  <div class="vd-gl-content">
    <a-upload
      accept=".xlsx,.xls,.csv"
      :multiple="true"
      :action="upload_url"
      @change="onChange"
      list-type="text"
      :file-list="fileList"
    >
      <div>
        <template v-if="fileList.length === 0">
          <a-button>
            <a-icon type="upload" />
            上传文件
          </a-button>
        </template>
      </div>
    </a-upload>
    <a-divider />
    <a-button @click="standard_excel">
      <a-icon type="download" />
      开始格式化
    </a-button>
  </div>
</template>

<script>
import { standard_excel } from '@/api/tool'

export default {
  name: 'standard_excel',
  data() {
    let baseURL =
      process.env.NODE_ENV === 'development'
        ? process.env.VUE_APP_DEVELOPMENT_URL
        : process.env.VUE_APP_PRODUCTION_URL
    let upload_url = baseURL + '/api/v1/upload_excel'
    return {
      upload_url,
      fileList: [],
      wait: true,
    }
  },
  methods: {
    onChange(e) {
      let status = e.file.status
      // let _file = e.file
      // let new_file
      // console.log(status)
      // console.log(e)
      if (status === 'uploading') {
        this.wait = false
        this.fileList = e.fileList
      } else if (status === 'done') {
        this.wait = true

        // new_file = {
        //   uid: _file.uid,
        //   name: _file.name,
        //   status: 'done',
        //   url: _file.response.info.web_url,
        //   thumbUrl: _file.response.info.web_url,
        // }
        e.fileList.forEach((item) => {
          if (item.status === 'done') {
            if (item.response.code === 1) {
              item.thumbUrl = item.response.file_path
            }
          }
          return item
        })

        this.fileList = e.fileList
      } else if (status === 'error') {
        this.wait = true
        console.log('上传错误')
      } else if (status === 'removed') {
        this.wait = true
        this.fileList = e.fileList
      }
    },

    standard_excel() {
      if (!this.wait) {
        this.$message.warning('请等待文件上传完成')
        return false
      }
      if (this.fileList.length === 0) {
        this.$message.warning('请选择要上传文件')
        return false
      }
      if (this.fileList[0]['thumbUrl'] === '') {
        this.$message.warning('上传错误!,请联系管理员')
        return false
      }
      standard_excel({
        file_path: this.fileList[0]['thumbUrl'],
      }).then((res) => {
        if (res) {
          const disposition = res.headers['content-disposition']
          let fileName = disposition.substring(
            disposition.indexOf('filename=') + 9,
            disposition.length
          )
          let link = document.createElement('a')
          link.style.display = 'none'
          let url = window.URL.createObjectURL(new Blob([res.data]))
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)
        }
      })
    },
  },
}
</script>

<style scoped></style>
